import React, { useEffect, useState } from "react";
import { useLocalStorage } from "react-use";

import {
  Box,
  ExpandableSection,
  FormField,
  Input,
  SpaceBetween,
} from "@cloudscape-design/components";

const HoneyCalculator: React.FC = () => {
  const [currentGravity, setCurrentGravity] = useState<string>("1.000");
  const [targetGravity, setTargetGravity] = useState<string>("1.000");
  const [honeyNeeded, setHoneyNeeded] = useState<string>("0.00");
  const [mustVolume, setMustVolume] = useState<string>("25");

  const [expanded, setExpanded] = useLocalStorage("expandedHoney", true);

  const honeyGravity = 1.42; // Specific gravity of honey
  const honeyDensity = 1.36; // Density of honey in kg/L

  const calculateHoneyNeeded = (
    current: number,
    target: number,
    volume: number
  ) => {
    if (target <= current || target >= honeyGravity) return 0;

    // Volume of honey (in liters) required to reach the target gravity
    const honeyVolume =
      ((target - current) * volume) / (honeyGravity - target);

    return honeyVolume * honeyDensity;
  };

  useEffect(() => {
    const cg = parseFloat(currentGravity);
    const tg = parseFloat(targetGravity);
    const vol = parseFloat(mustVolume);

    if (cg && tg && vol) {
      setHoneyNeeded(calculateHoneyNeeded(cg, tg, vol).toFixed(2));
    }
  }, [currentGravity, targetGravity, mustVolume]);

  return (
    <ExpandableSection
      expanded={expanded}
      onChange={({ detail }) => setExpanded(detail.expanded)}
      headerText="Honey Calculator"
    >
      <Box>
        Enter your current gravity, desired gravity and must volume to
        estimate how much honey you need to add.
      </Box>
      <SpaceBetween size="m">
        <FormField label="Current gravity">
          <Input
            value={currentGravity}
            onChange={({ detail }) => setCurrentGravity(detail.value)}
          />
        </FormField>
        <FormField label="Target gravity">
          <Input
            value={targetGravity}
            onChange={({ detail }) => setTargetGravity(detail.value)}
          />
        </FormField>
        <FormField label="Must vol (L.)">
          <Input
            value={mustVolume}
            onChange={({ detail }) => setMustVolume(detail.value)}
          />
        </FormField>
        <FormField label="Honey needed (kg)">
          <Input value={honeyNeeded} readOnly />
        </FormField>
      </SpaceBetween>
    </ExpandableSection>
  );
};

export default HoneyCalculator;
